var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import widgetsDictionary from "@/components/widgets/widgetsDictionary";
import { useState } from "react";
import { usePopup } from "@/hooks/layout";
import { useLogger } from "@/utils/loggerService";
import WidgetEditor from "./widgetEditor";
import { ButtonGroup, IconButton } from "@mui/joy";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock, faLockOpen } from "@fortawesome/pro-solid-svg-icons";
export default function WidgetParamEditor(_a) {
    var _this = this;
    var _b;
    var widget = _a.widget;
    var logger = useLogger().logger;
    var closePopup = usePopup().closePopup;
    var params = (widget === null || widget === void 0 ? void 0 : widget.payload) || {};
    var selectedWidget = (params === null || params === void 0 ? void 0 : params.widget) || {};
    var widgetDefinition = widgetsDictionary.get(selectedWidget === null || selectedWidget === void 0 ? void 0 : selectedWidget.type);
    var setUpdate = function (value) {
        setEditedWidget(value);
    };
    var _c = useState(selectedWidget), editedWidget = _c[0], setEditedWidget = _c[1];
    var t = useTranslation(["common"]).t;
    return (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: "flex flex-col min-w-[800px]" }, { children: [_jsxs("div", __assign({ className: "flex flex-rows mb-4" }, { children: [_jsx("h2", __assign({ className: "font-bold" }, { children: t("app.LBL_WIDGET_CONFIG", { ns: "common" }) })), _jsx(ButtonGroup, __assign({ sx: {
                                    backgroundColor: "var(--color-brand-neutral-50)",
                                    "--icon-color": "red",
                                    transition: "all 0.25s",
                                    ":hover": {
                                        opacity: 1,
                                    },
                                } }, { children: _jsx(IconButton, __assign({ sx: {
                                        width: "40px",
                                        border: "none",
                                        marginTop: "-8px",
                                    }, onClick: function () {
                                        var _a;
                                        var updated = __assign(__assign({}, editedWidget), { meta: __assign(__assign({}, editedWidget.meta), { pinned: !((_a = editedWidget.meta) === null || _a === void 0 ? void 0 : _a.pinned) }) });
                                        setEditedWidget(updated);
                                    } }, { children: _jsx(FontAwesomeIcon, { icon: ((_b = editedWidget === null || editedWidget === void 0 ? void 0 : editedWidget.meta) === null || _b === void 0 ? void 0 : _b.pinned) ? faLock : faLockOpen }) })) }))] })), widgetDefinition && (_jsx("div", __assign({ className: "grid grid-cols-2 border-2 border-gray-300 rounded-sm" }, { children: _jsx(WidgetEditor, { selected: editedWidget, update: setUpdate, widgetDefinition: widgetDefinition }) })))] })), _jsxs("div", __assign({ className: "mt-8 mb-4 text-center md:text-right md:flex md:justify-end" }, { children: [_jsx("button", __assign({ className: "button danger block w-full px-4 py-3 text-sm font-semibold md:inline-block md:w-auto md:py-2 md:ml-2 md:order-2", onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                closePopup(widget.id, editedWidget, widget.slot);
                                logger.debug("[WIDGET SELECTOR] - Select", editedWidget);
                                return [2 /*return*/];
                            });
                        }); } }, { children: "Valider" })), _jsx("button", __assign({ className: "button secondary block w-full px-4 py-3 mt-4 text-sm font-semibold md:inline-block md:w-auto md:py-2 md:mt-0 md:order-1", onClick: function () {
                            closePopup(widget.id, undefined, widget.slot);
                            logger.debug("[WIDGET SELECTOR] - Cancel", editedWidget);
                        } }, { children: "Annuler" }))] }))] }));
}
widgetsDictionary.register("widget/editor", {
    name: "Editeur de paramètres de widget",
    display: WidgetParamEditor,
    selectable: false,
    editable: false,
});
